/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

/**
      * CancelPendingRoleChangeOutcome is the result of cancelling a pending role
request. Repeating a cancellation is idempotent.

 - CANCEL_PENDING_ROLE_CHANGE_OUTCOME_CANCELLED: Cancellation settled; the role will not be granted by this request.
 - CANCEL_PENDING_ROLE_CHANGE_OUTCOME_CANCELLATION_PENDING: Cancellation was recorded but in-flight work has not settled, so the
outcome is uncertain (an activation already in progress may still
complete). Retry or read later until CANCELLED or ALREADY_APPLIED.
 - CANCEL_PENDING_ROLE_CHANGE_OUTCOME_ALREADY_APPLIED: The role was already granted before cancellation; remove it through
the ordinary role-removal path instead.
      * @Example No example provided
      */
export enum CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeOutcome {
  CANCEL_PENDING_ROLE_CHANGE_OUTCOME_UNSPECIFIED = 'CANCEL_PENDING_ROLE_CHANGE_OUTCOME_UNSPECIFIED',
  CANCEL_PENDING_ROLE_CHANGE_OUTCOME_CANCELLED = 'CANCEL_PENDING_ROLE_CHANGE_OUTCOME_CANCELLED',
  CANCEL_PENDING_ROLE_CHANGE_OUTCOME_CANCELLATION_PENDING = 'CANCEL_PENDING_ROLE_CHANGE_OUTCOME_CANCELLATION_PENDING',
  CANCEL_PENDING_ROLE_CHANGE_OUTCOME_ALREADY_APPLIED = 'CANCEL_PENDING_ROLE_CHANGE_OUTCOME_ALREADY_APPLIED',
}
export const getCoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeOutcomeErrors = (
  value: unknown,
): { fieldName: string; error: string }[] => {
  if (process.env.NODE_ENV === 'production') return [];
  if (
    !Object.values(CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeOutcome).includes(
      value as any,
    )
  ) {
    return [
      {
        fieldName: '',
        error: ` ${value} is not a valid CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeOutcome.`,
      },
    ];
  } else {
    return [];
  }
};

const validateCoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeOutcome = (
  value: unknown,
) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeOutcomeErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeOutcome data does not match contract.`,
      errors,
    );
  }
};
